import React, { useEffect, useState, useRef } from 'react';
import { app } from '../firebase.js';
import { getFirestore, collection, query, where, getDocs } from 'firebase/firestore';
import html2pdf from 'html2pdf.js';
import logo from '../Images/logo-main-black.png'

function ViewReceipt() {

  const [receiptData, setReceiptData] = useState(null);
  const [studentName, setStudentName] = useState('');
  const [admissionNumber, setAdmissionNumber] = useState('');
  const receiptRef = useRef();
  const receivedId = decodeURIComponent(window.location.search);
  const docID = receivedId.substring(1);
  const db = getFirestore(app);

  console.log(docID)

  useEffect(() => {
    const fetchReceipt = async () => {
      try {
        const q = query(collection(db, 'Income'), where('invoiceNumber', '==', docID));
        const querySnapshot = await getDocs(q);
        if (!querySnapshot.empty) {
          const data = querySnapshot.docs[0].data();
          setReceiptData(data);

          // Fetch user from "users" collection using studentId
          const userQuery = query(collection(db, 'users'), where('userId', '==', data.studentId));
          const userSnapshot = await getDocs(userQuery);
          if (!userSnapshot.empty) {
            const userData = userSnapshot.docs[0].data();
            setStudentName(userData.bio || '');
            setAdmissionNumber(userData.admissionNumber || '');
          }
        } else {
          console.error("Receipt not found");
        }
      } catch (error) {
        console.error("Error fetching receipt:", error);
      }
    };

    fetchReceipt();
  }, [docID]);

  const exportPDF = () => {
    const element = receiptRef.current;
    html2pdf().from(element).save(`${docID}_receipt.pdf`);
  };

  return (
    <div className="container py-5">
      {receiptData ? (
        <>
          <div ref={receiptRef} className="bg-white p-5 border rounded shadow-sm" style={{ maxWidth: "800px", margin: "0 auto" }}>
            <div className="text-center mb-4">
                <img src={logo} className='receiptLogo' alt="" />
              <h2 className="fw-bold mb-0">PAYMENT RECEIPT</h2>
              <small className="text-muted">Official Fee Payment Receipt</small>
            </div>

            <hr />

            <div className="d-flex justify-content-between mb-3">
              <div>
                <h6 className="fw-semibold">Student Info</h6>
                <p className="mb-1"><strong>Name:</strong> {studentName}</p>
                <p className="mb-1"><strong>Admission Number:</strong> {admissionNumber}</p>
              </div>
              <div>
                <h6 className="fw-semibold">Invoice</h6>
                <p className="mb-1"><strong>Invoice No:</strong> {receiptData.invoiceNumber}</p>
                <p className="mb-1"><strong>Date:</strong> {receiptData.paymentDate.toDate().toLocaleDateString()}</p>
              </div>
            </div>

            <table className="table table-bordered mt-3">
              <thead className="table-light">
                <tr>
                  <th>Description</th>
                  <th>Payment Method</th>
                  <th className="text-end">Amount (KES)</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>Fee Payment</td>
                  <td>{receiptData.paymentMethod}</td>
                  <td className="text-end">{Number(receiptData.incomeAmount).toLocaleString()}</td>
                </tr>
              </tbody>
            </table>

            <div className="text-end mt-3">
              <h5 className="fw-bold">Total: KES {Number(receiptData.incomeAmount).toLocaleString()}</h5>
            </div>

            <div className="mt-4 text-muted small text-center">
              <p>Thank you for your payment. This receipt is computer-generated and does not require a signature.</p>
            </div>
          </div>

          <div className="text-center mt-4">
            <button onClick={exportPDF} className="btn btn-outline-primary px-4">
              Download as PDF
            </button>
          </div>
        </>
      ) : (
        <p className="text-center">Loading receipt...</p>
      )}
    </div>
  );
}

export default ViewReceipt;